import * as React from 'react';
import '../css/stacked-image-content.sass';
import { ProgramDetail } from './ProgrammingLockup';
import ImageLockup from './ImageLockup';

export interface ImageDetail {
  url: string;
  alt: string;
  detail?: ProgramDetail;
}

interface StackedImageProps {
  primary: ImageDetail;
  secondary: ImageDetail;
  teritiary: ImageDetail;
}

const stackedImage = (image: ImageDetail) => {
  return <ImageLockup url={image.url} alt={image.alt} detail={image.detail} />;
};

export default function StackedImageContent(props: StackedImageProps) {
  return (
    <div className="stack-container">
      {stackedImage(props.primary)}
      {stackedImage(props.secondary)}
      {stackedImage(props.teritiary)}
    </div>
  );
}
